import { generatePath } from 'react-router';

import { SurveyLanguage } from '@/graphql/generated';

import { Loader } from '@/components/generic/Loader';
import { TooltipWrapper } from '@/components/generic/TooltipWrapper';
import { ExportIcon } from '@/components/icons';
import {
  ApiDownloadRoutes,
  useDownloadFileLegacy,
} from '@/hooks/useDownloadFileLegacy';
import { useTranslation } from '@/hooks/useTranslation';

export function ExportReferentialButton({
  referentialId,
  language,
}: {
  referentialId: string;
  language: SurveyLanguage;
}) {
  const { t } = useTranslation();
  const { downloadFile, loading } = useDownloadFileLegacy({
    errorToastMessage: t('toast:survey.export.error'),
    fileName: `${t('nav:page.referential')}.xlsx`,
    path: generatePath(ApiDownloadRoutes.ReferentialExport, {
      referentialId: referentialId,
    }),
    exportToLanguage: language,
  });

  return (
    <TooltipWrapper label={t('referential.export.help')}>
      <button className="tertiary" onClick={downloadFile} disabled={loading}>
        {loading ? <Loader /> : <ExportIcon />}
      </button>
    </TooltipWrapper>
  );
}
